import { Injectable } from '@angular/core';
import { AvatarDatabaseManagerProvider } from './avatar-database-manager/avatar-database-manager';
import { User } from '../../bayadic-shared-models/classes/user/User';
import { SocketManagerProvider } from '../socket-manager/socket-manager';
import { LoggerService } from '../../app/services/logger.service';
/*
  Generated class for the AvatarsManagerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AvatarsManagerProvider {

  constructor(
    public avatarDatabaseManager : AvatarDatabaseManagerProvider,
    public socketManager : SocketManagerProvider,
    public logger: LoggerService
  )  {
    this.logger.debug('Hello AvatarsManagerProvider Provider');
  }
  getUserByUserID(user : User) : Promise<User>{
    return new Promise((resolve)=>{
      this.avatarDatabaseManager.getUserByUserID(user).then(userFoundDB=>{
        if(userFoundDB.email == undefined){
          this.getUserFromServer(user).then(userFoundOnline=>{
            resolve(userFoundOnline);
          });
        }else{
          resolve(userFoundDB);
        }
      })
    })
  }
  getUserFromServer(user: User): Promise<User> {
    return new Promise((resolve)=>{
      this.socketManager.asyncQuery<GetUserDataResponse, any>("getUserData",{userID : user.userID}).then(response=>{
        let user = new User(response.userData);
        this.avatarDatabaseManager.save(user);
        resolve(user);
      })
    })
  }

}
interface GetUserDataResponse {
  userData: any;
}